import styles from './content_placeholder.module.css';

export const ContentPlaceholder = ({lines = 5}: Props) => {
  return (
    <div className={styles.container}>
      {[...Array(lines).keys()].map((_, index) => (
        <div key={index} className={styles.line} />
      ))}
    </div>
  );
};

type Props = {
  lines?: number;
};
